// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2759": "7d94a73d","3473": "cc576b18","4636": "bb3c224b",}[chunkId] + ".css"
}